{
  "title": "Protection from Energy",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level abjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "For the duration, the willing creature you touch has resistance to one damage type of your choice: acid, cold, fire, lightning, or thunder."
  ],
  "spellLists": ["artificer", "cleric", "druid", "eldritch-knight", "ranger", "sorcerer", "wizard"]
}
